export type OverallStatus = "good" | "warning" | "error";

const STATUS_FAVICON: Record<OverallStatus, string> = {
  good: "icon.png",
  warning: "icon-warning.png",
  error: "icon-error.png",
};

export function statusFaviconHref(
  status: OverallStatus,
  hasEnvironments = true,
): string {
  const file = hasEnvironments ? STATUS_FAVICON[status] : STATUS_FAVICON.good;
  const base = process.env.PUBLIC_URL ?? "";
  const prefix = base.endsWith("/") ? base.slice(0, -1) : base;
  return `${prefix}/${file}`;
}

export function applyStatusFavicon(
  status: OverallStatus,
  hasEnvironments = true,
): void {
  if (typeof document === "undefined") return;

  const href = statusFaviconHref(status, hasEnvironments);
  const existing = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (existing?.getAttribute("href") === href) return;

  const next = document.createElement("link");
  next.rel = "icon";
  next.type = "image/png";
  next.href = href;

  if (existing) {
    existing.replaceWith(next);
  } else {
    document.head.appendChild(next);
  }
}
